import React from "react";
import { Link } from "react-router-dom";

function Offer() {
  const data = [
    {
      id: 1,
      name: "Saving your money",
      dis: "We denounce with righteou indigntion and dislike men beguile demoralized by the charms of pleasure moment",
    },
    {
      id: 2,
      name: "Easy process system",
      dis: "On the other hand, we denounce with righteous indignation beg demoralized charms of pleasure moment",
    },
    {
      id: 3,
      name: "Mobile banking system",
      dis: "Quis autem veleumiure reprehenderit quin ea voluptate velit esse quam nihile molestiae consequ aturillum dolore",
    },
  ];
  return (
    <>
      <section className="about-six">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">What We Offer</p>

            <h3 className="sec-title__title">
              Great insurance build better <br />
              future together
            </h3>
          </div>

          <div className="row gutter-y-30">
            {data.map((item) => (
              <div
                key={item.id}
                className="col-md-12 col-lg-4 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="000ms"
              >
                <div className="about-six__card">
                  <div className="about-six__card__icon">
                    <i className="fas fa-check" />
                  </div>

                  <h3 className="about-six__card__title">
                    <Link to="#">{item.name}</Link>
                  </h3>

                  <div className="about-six__card__text">{item.dis}</div>

                  <Link to="/about" className="thm-btn about-six__card__btn">
                    <span>
                      Read More
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer;
